import { Injectable } from '@rxdi/core';
import { render, TemplateResult } from '@rxdi/lit-html';

@Injectable()
export class PortalProvider {
  private div: HTMLDivElement;
  attach(template: TemplateResult, rect?: { top: number; left: number }) {
    this.dettach();
    this.div = document.createElement('div');
    this.div.style.position = 'absolute';
    this.div.style.top = `${rect.top || 0}px`;
    this.div.style.left = `${rect.left || 0}px`;
    this.div.style.zIndex = '100000';
    render(template, this.div);
    document.body.appendChild(this.div);
  }

  dettach() {
    this.div?.remove();
  }
}
